module.exports = __webpack_public_path__ + "static/media/manual.a58b0760.pdf";